<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-bar-chart-2" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Fund Management</h4>
              <small style="opacity: .8;">Overview of payments, claims and capitations</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Stat Cards ── -->
        <div class="row mb-4">
          <div class="col-md-4 mb-3">
            <div class="stat-card stat-card--blue">
              <div class="stat-icon">
                <i class="fe fe-credit-card"></i>
              </div>
              <div>
                <p class="stat-label">Total Payments Received</p>
                <h3 class="stat-value">
                  <i class="mdi mdi-currency-ngn"></i>{{ funds_dashboard.total_amount_paid | numeral(0, 0) }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="stat-card stat-card--purple">
              <div class="stat-icon">
                <i class="fe fe-database"></i>
              </div>
              <div>
                <p class="stat-label">Claims Payment</p>
                <h3 class="stat-value">
                  <i class="mdi mdi-currency-ngn"></i>{{ funds_dashboard.sum_of_claims_paid | numeral(0, 0) }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="stat-card stat-card--green">
              <div class="stat-icon">
                <i class="fe fe-users"></i>
              </div>
              <div>
                <p class="stat-label">Capitations</p>
                <h3 class="stat-value">
                  <i class="mdi mdi-currency-ngn"></i>{{ captitations | numeral(0, 0) }}
                </h3>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Payments Table ── -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center flex-wrap px-4 pt-4 pb-3" style="gap: 10px;">
            <i class="fe fe-list text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold mr-auto">Summary</h6>
            <label class="small text-muted mb-0 mr-2">Status</label>
            <select class="form-control form-control-sm" style="width: auto;" v-model="statusFilter"
              @change="getPayments(1)">
              <option value="">All</option>
              <option value="pending">Pending</option>
              <option value="paid">Paid</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Date</th>
                  <!-- <th class="table-th">Payment Order Number</th> -->
                  <th class="table-th">Recipient</th>
                  <th class="table-th">Status</th>
                  <th class="table-th">Number of Claims</th>
                  <th class="table-th">Amount</th>

                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="payment in payments.data" v-bind:key="payment.id">
                  <td class="py-2" style="font-size:.85rem;">{{ payment.created_at }}</td>
                  <!-- <td class="py-2"><span class="code-chip">#{{ payment.payment_number }}</span></td> -->

                  <td class="py-2">{{ payment.provider.agency_name }}</td>
                  <td class="py-2">
                    <span class="badge badge-soft-success" v-if="payment.status == 'paid'">
                      <i class="mdi mdi-check-circle mr-1"></i>{{ payment.status }}
                    </span>
                    <span class="badge badge-soft-warning" v-if="payment.status == 'pending'">
                      <i class="fe fe-clock mr-1"></i>{{ payment.status }}
                    </span>
                  </td>
                  <td class="py-2 font-weight-bold">{{ payment.claims_count }}</td>
                  <td class="py-2"><span class="code-chip"><i class="mdi mdi-currency-ngn"></i>{{ payment.claim_amount |
                      numeral(0, 0)
                      }}</span></td>
                  <td class="py-2">
                    <div class="d-flex" style="gap: 4px;">
                      <router-link :to="`/claims/transaction/${payment.id}`">
                        <button type="button" class="btn btn-sm btn-outline-primary">
                          <i class="fe fe-eye mr-1"></i> View
                        </button>
                      </router-link>
                      <button type="button" class="btn btn-sm btn-outline-success"
                        :disabled="downloadingCsvId === payment.id" @click="downloadClaimsCsv(payment)">
                        <span v-if="downloadingCsvId === payment.id">
                          <span class="spinner-border spinner-border-sm"></span>
                        </span>
                        <span v-else><i class="fe fe-download mr-1"></i> CSV</span>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!payments.data || !payments.data.length">
                  <td colspan="7" class="text-center py-5 text-muted">
                    <i class="fe fe-inbox" style="font-size:2rem;opacity:0.3;"></i>
                    <p class="mt-2 mb-0">No payments found</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body pt-2" v-if="payments.total">
            <b-pagination v-model="currentPage" :total-rows="payments.total" :per-page="payments.per_page || 15"
              @input="getPayments(currentPage ? currentPage : 1)"></b-pagination>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Navbar,
    },
    data() {
      return {
        agency: agency,
        captitations: 0,
        funds_dashboard: "",
        payments: "",
        user: null,
        currentPage: 1,
        statusFilter: "pending",
        downloadingCsvId: null,
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    methods: {
      getPaymentAgency(currentPage) {
        this.axios
          .get(`/api/v1/auth/paymentorder-agency/${agency.id}`, {
            params: {
              type: "claims",
              page: currentPage,
              status: this.statusFilter,
            },
          })
          .then((response) => {
            this.payments = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getPaymentProvider(currentPage) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/paymentorder-provider/${this.user.id}`, {
            params: {
              page: currentPage,
              status: this.statusFilter,
            },
          })
          .then((response) => {
            this.payments = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getDashboardAgency() {
        this.axios
          .get(`/api/v1/auth/finance-dashboard-agency/${agency.id}`)
          .then((response) => {
            this.funds_dashboard = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getDashboardProvider() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/finance-dashboard-provider/${this.user.id}`)
          .then((response) => {
            this.funds_dashboard = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getPayments(currentPage) {
        this.user = JSON.parse(localStorage.getItem("user"));
        if (this.user.type == "employee" || this.user.type == "shis") {
          this.getPaymentAgency(currentPage);
        } else {
          this.getPaymentProvider(currentPage);
        }
      },

      getDashboard() {
        this.user = JSON.parse(localStorage.getItem("user"));
        if (this.user.type == "employee" || this.user.type == "shis") {
          this.getDashboardAgency();
        } else {
          this.getDashboardProvider();
        }
      },

      downloadClaimsCsv(payment) {
        this.downloadingCsvId = payment.id;
        this.axios
          .get(`/api/v1/auth/paymentorder/${payment.id}`)
          .then((response) => {
            const claims = (response.data.data && response.data.data.claims) || [];
            if (!claims.length) {
              this.$toasted.info("No claims found for this payment order.", {
                position: "top-center",
                duration: 3000,
              });
              return;
            }

            const headers = [
              "Claim ID",
              "Claim Unique ID",
              "Enrollee Name",
              "Enrollee ID",
              "Authorization Code",
              "Seen Date",
              "Claim Status",
              "Requested Amount",
              "Approved Amount",
              "Rejected Amount",
              "Verified By Date",
              "Approved By Date",
            ];
            const rows = claims.map((claim) => [
              claim.id,
              claim.claim_unique_id,
              claim.enrollee ? claim.enrollee.full_name : "",
              claim.enrollee ? claim.enrollee.id_card_number : "",
              claim.authorization_code,
              claim.seen_date,
              claim.claim_status,
              claim.requested_total_cost,
              claim.approved_total_cost,
              claim.rejected_total_cost,
              claim.verified_by_date,
              claim.approved_by_date,
            ]);

            this.downloadCsv(headers, rows, `payment-order-${payment.payment_number}-claims`);
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Failed to fetch claims for this payment order.", {
              position: "top-center",
              duration: 3000,
            });
          })
          .finally(() => {
            this.downloadingCsvId = null;
          });
      },

      downloadCsv(headers, rows, filename) {
        const escapeCell = (val) => {
          const str = val === null || val === undefined ? "" : String(val);
          if (str.includes(",") || str.includes('"') || str.includes("\n")) {
            return `"${str.replace(/"/g, '""')}"`;
          }
          return str;
        };
        const lines = [headers, ...rows].map((row) => row.map(escapeCell).join(","));
        const csv = lines.join("\n");
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.csv`;
        a.click();
        URL.revokeObjectURL(url);
      },
    },
    created() {
      this.getPayments();
      this.getDashboard();
    },
  };
</script>
<style scoped>
  /* ── Stat Cards ── */
  .stat-card {
    display: flex;
    align-items: center;
    gap: 18px;
    border-radius: 14px;
    padding: 22px 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
    color: #fff;
    height: 100%;
  }

  .stat-card--blue {
    background: linear-gradient(135deg, #1e3a5f, #2563eb);
  }

  .stat-card--purple {
    background: linear-gradient(135deg, #4c1d95, #7c3aed);
  }

  .stat-card--green {
    background: linear-gradient(135deg, #065f46, #10b981);
  }

  .stat-icon {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    background: rgba(255, 255, 255, .2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
  }

  .stat-label {
    margin: 0;
    font-size: .78rem;
    text-transform: uppercase;
    letter-spacing: .05em;
    opacity: .85;
  }

  .stat-value {
    margin: 2px 0 0;
    font-weight: 700;
  }

  /* ── Payments Table: force horizontal scroll instead of cramped wrapping ── */
  .table-responsive .table {
    width: auto;
    min-width: 700px;
  }

  .table-responsive .table th,
  .table-responsive .table td {
    white-space: nowrap;
  }
</style>